// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xw x2","addMyListButton":"xx ya"};